import { Component, Inject, Input } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';

@Component({
  selector: 'ui-fh-status',
  templateUrl: './fh-status.component.html',
  styleUrl: './fh-status.component.scss'
})
export class FhStatusComponent {
  @Input() status: string = '';
  @Input() translateKeyPrefix: string = ''
  @Input() useHeaderCard: boolean = false;

  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(@Inject(APP_CONFIG) appConfigTemp: EnvironmentModel) {
    this.appConfig = appConfigTemp;
  }
}
